import { DoorOpen, Play, Square, QrCode, Users, Pencil, Trash2 } from 'lucide-react'

import { Button } from '@/ui/button'
import type { ClassSession } from '@/features/classes/stores'

interface SessionActionsProps {
  session: ClassSession
  loading?: boolean
  onOpenCheckin: () => void
  onBeginClass: () => void
  onEndClass: () => void
  onShowQR: () => void
  onAddStudent: () => void
  onEdit: () => void
  onCancelClass: () => void
}

export function SessionActions({
  session,
  loading,
  onOpenCheckin,
  onBeginClass,
  onEndClass,
  onShowQR,
  onAddStudent,
  onEdit,
  onCancelClass,
}: SessionActionsProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {session.status === 'draft' && (
        <>
          <Button onClick={onOpenCheckin} disabled={loading}>
            <DoorOpen className="w-4 h-4" />
            Open Check-in
          </Button>
          <Button variant="outline" onClick={onEdit} disabled={loading}>
            <Pencil className="w-4 h-4" />
            Edit Class
          </Button>
          <Button variant="destructive" onClick={onCancelClass} disabled={loading}>
            <Trash2 className="w-4 h-4" />
            Cancel Class
          </Button>
        </>
      )}

      {session.status === 'checking' && (
        <>
          <Button onClick={onBeginClass} disabled={loading}>
            <Play className="w-4 h-4" />
            Begin Class
          </Button>
          <Button variant="outline" onClick={onShowQR} disabled={loading}>
            <QrCode className="w-4 h-4" />
            Show QR
          </Button>
          <Button variant="outline" onClick={onAddStudent} disabled={loading}>
            <Users className="w-4 h-4" />
            Add Student
          </Button>
        </>
      )}

      {session.status === 'active' && (
        <>
          <Button variant="destructive" onClick={onEndClass} disabled={loading}>
            <Square className="w-4 h-4" />
            End Class
          </Button>
          <Button variant="outline" onClick={onShowQR} disabled={loading}>
            <QrCode className="w-4 h-4" />
            Show QR
          </Button>
          <Button variant="outline" onClick={onAddStudent} disabled={loading}>
            <Users className="w-4 h-4" />
            Add Student
          </Button>
        </>
      )}

      {session.status === 'closed' && (
        <Button variant="outline" onClick={onShowQR} disabled={loading}>
          <QrCode className="w-4 h-4" />
          Show QR
        </Button>
      )}
    </div>
  )
}
